<ng-container>
  <div class="myaccount-personal-wrapper">
    @if (isEditDealerInfoEnabled$ | async) {
    <div class="personal-header-wrapper">
      <h2>{{ 'personalInfo.title' | cxTranslate }}</h2>
      @if (isRequestDeleteAccountEnabled$ | async) {
      <div class="request-delete-account-wrapper">
        @if (isAdmin) {
        <button
          mat-button
          class="btn primary-btn"
          [disabled]="isRequestDeletionDisabled"
          [class.disabled]="isRequestDeletionDisabled"
          [ngClass]="activeLanguage$ | async"
          (click)="onRequestDeletion()"
        >
          {{ 'myAccount.requestDeleteAccount' | cxTranslate }}
        </button>
        }
      </div>
      }
    </div>
    } @if (hasPendingRequest && (isCustomTranslationsEnabled$ | async) !== null) {
    <div class="myaccount-personal-info-pending alert alert-info alert-dismissible fade show" role="alert">
      <mat-icon class="material-icons-outlined">error_outline</mat-icon>
      {{
        'personalInfo.hasPending'
          | cxTranslate
            : {
                context: setCustomContext(
                  isCustomTranslationsEnabled$ | async,
                  activeCountry$ | async,
                  activeLanguage$ | async
                )
              }
      }}
    </div>
    }
    <div class="myaccount-personal-container">
      @if (isEditDealerInfoEnabled$ | async) {
      <div class="myaccount-personal-form" [ngClass]="{ hide: this.count === 0 }">
        <app-dynamic-form
          (formGroupEmit)="updateFormGroup($event)"
          (formModelEmit)="updateFormModel($event)"
          [emitOnInit]="true"
          [formGroupId]="'UPDATE_CONTACT_INFO'"
          [static]="false"
          [formChange]="true"
          [fieldChange]="'deliveryCountry'"
          [activeLanguage]="activeLanguage$ | async"
        ></app-dynamic-form>
      </div>
      }
      <div class="personal-button" [style.bottom.px]="getFooterHeight()">
        <div class="save-button-wrapper">
          @if (isEditDealerInfoEnabled$ | async) {
          <button
            mat-button
            [class.disabled]="isBtnDisabled"
            [disabled]="isBtnDisabled"
            (click)="updatePersonalInfoModal()"
            class="btn btn-primary"
          >
            {{ 'personalInfo.requestButton' | cxTranslate }}
          </button>
          }
          <button
            mat-button
            class="btn-outline-primary"
            [routerLink]="
              {
                cxRoute: 'myAccount'
              } | cxUrl
            "
          >
            {{ 'common.cancel' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
